import { makeStyles } from '@material-ui/core/styles';

export default () => {
    return makeStyles(theme => ({
        checkboxCenter: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        centerLabel: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'right',
        },
        button: {
            height: "55px",
            borderRadius: "0 10px 10px 0"
        },
        titlePopover: {
            fontWeight: "bold"
        },
        flexSeach: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }
    }));
};
